/*! custom-nativo.js — modo "Rolagem nativa em tudo"

    Terceiro metodo de rolagem dos carrosseis, ao lado do Embla. A mecanica e a
    do squadzmuscle.com.br, cujo tema o cliente forneceu como referencia de
    fluidez (SQUADZ_theme/assets/carousel-drag-v2.js).

    A ideia central, e o motivo de existir este arquivo: NO TOQUE NAO RODA
    JAVASCRIPT NENHUM. O carrossel vira um container de rolagem nativa com
    scroll-snap, e quem move e o compositor do navegador. Motor de carrossel —
    Blaze ou Embla — escreve `transform` a cada quadro no thread principal, e
    nenhum ajuste fino fecha essa diferenca: e arquitetura.

    O JavaScript daqui cuida so do que a rolagem nativa nao da de graca:
      - arrasto com o MOUSE no desktop (container de rolagem nao se arrasta com
        botao esquerdo; responde a roda e trackpad)
      - autoplay, via scrollTo
      - loop continuo, por duplicacao de slides (so onde nao ha card de produto)
      - setas, paginacao e barra de progresso do tema

    E o unico metodo de rolagem do tema: o Embla e o modo nativo antigo foram
    removidos, junto com o seletor que escolhia entre eles. */

(function () {
  'use strict';

  /* limiares do arrasto de mouse, iguais aos da referencia */
  var LIMIAR_ARRASTO = 4; // px para considerar que virou arrasto
  var LIMIAR_CLIQUE = 6; // px a partir dos quais o clique final e anulado
  var PRAZO_ACOMODACAO = 700; // teto para a classe is-dragging sempre sair

  function pronto(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function ajusteTexto(nome) {
    return String(getComputedStyle(document.documentElement).getPropertyValue(nome) || '')
      .trim()
      .replace(/^["']|["']$/g, '');
  }

  function limiteConfigurado(nome) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(nome);
    var n = parseInt(String(v).trim(), 10);
    return isNaN(n) || n < 1 ? 0 : n;
  }

  /*
    Limite de produtos por vitrine — Configuracoes do tema > Vitrines e cards
    de produto. Estava no custom-embla.js; veio para ca quando aquele arquivo
    saiu do tema, senao os controles de "maximo de produtos" parariam de
    fazer efeito.

    O limite do tema e aplicado no Liquid e o mesmo HTML serve os dois
    tamanhos, entao a poda so pode acontecer no navegador. Depois dela
    chamamos o reload() do proprio <simple-carousel>, que reconstroi slider,
    paginacao, setas e barra — e troca o .blaze-track inteiro, o que a
    deteccao de remontagem em montar() ja sabe tratar.
  */
  function podarVitrine(sc) {
    if (!sc || typeof sc.reload !== 'function') return;
    var celular = window.matchMedia('(max-width: 767px)').matches;
    var limite = limiteConfigurado(celular ? '--ep-vitrine-limite-mobile' : '--ep-vitrine-limite-desktop');
    if (!limite) return;
    var track = sc.querySelector('.blaze-track');
    if (!track || track.children.length <= limite) return;
    /* so vitrines de produto: nao mexemos em topbar, banner, videos */
    if (!track.querySelector('product-card, .product-card')) return;
    /* clones do loop nao contam como produto a podar */
    if (track.querySelector('[data-ep-clone]')) return;
    while (track.children.length > limite) {
      track.removeChild(track.lastElementChild);
    }
    sc.reload();
  }

  /* Mesma leitura de config do custom-embla: `slider.config` quando existe, e
     senao o data-slider-config do <simple-carousel>, resolvendo as media
     queries como o Blaze faz. */
  /*
    Config vinda do ATRIBUTO data-slider-config, resolvendo as media queries como
    o Blaze faz. E a fonte que o tema NAO altera em tempo de execucao.
  */
  function lerConfigAtributo(el) {
    var sc = el.closest('simple-carousel');
    var bruto = sc && sc.getAttribute('data-slider-config');
    if (!bruto) return {};
    try {
      var todas = JSON.parse(bruto);
      var out = {};
      Object.keys(todas).forEach(function (mq) {
        if (mq === 'all' || window.matchMedia(mq).matches) {
          Object.keys(todas[mq]).forEach(function (k) {
            out[k] = todas[mq][k];
          });
        }
      });
      return out;
    } catch (e) {
      return {};
    }
  }

  function lerConfig(el, slider) {
    if (slider && slider.config && typeof slider.config.loop !== 'undefined') return slider.config;
    return lerConfigAtributo(el);
  }

  /* O handler de arrasto do Blaze le `track.slider` para achar a instancia.
     Um getter que devolve algo "em transicao" faz ele desistir, sem precisar
     remover listener nenhum. */
  function desligarArrastoBlaze(track) {
    var d = Object.getOwnPropertyDescriptor(track, 'slider');
    if (d && !d.configurable) return;
    try {
      Object.defineProperty(track, 'slider', {
        configurable: true,
        get: function () {
          return { isTransitioning: true };
        },
        set: function () {}
      });
    } catch (e) {
      /* noop */
    }
  }

  // ---------------------------------------------------------------- medidas --

  /* Distancia entre o inicio de um slide e o do seguinte — inclui o gap. */
  function passo(trilha) {
    var f = trilha.children;
    if (f.length < 2) return f.length ? f[0].getBoundingClientRect().width : 0;
    return f[1].getBoundingClientRect().left - f[0].getBoundingClientRect().left;
  }

  function indiceAtual(scroller, trilha) {
    var p = passo(trilha);
    return p > 0 ? Math.round(scroller.scrollLeft / p) : 0;
  }

  function maxRolagem(scroller) {
    return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
  }

  /*
    Medidas em cache — o que tirou o custom-nativo.js do topo do Lighthouse.

    A cada evento de scroll de cada carrossel, o caminho quente lia
    getBoundingClientRect tres vezes (normalizar, barra, notificar) e escrevia
    estilo no meio; cada escrita suja o layout que a leitura seguinte forca.
    Num autoplay suave sao dezenas de eventos por passo, em varios carrosseis
    ao mesmo tempo. Medido em 11/09 com Lighthouse desktop: 1,65 s de
    execucao atribuidos a este arquivo e Style & Layout de 2,0 s para 4,1 s.

    O passo (largura do card + gap) e a largura visivel so mudam com resize,
    remontagem ou clone. Guardamos os dois e invalidamos nesses momentos.
    Zero nunca entra no cache: e o valor de um carrossel escondido
    (display: none), e ficaria errado quando ele aparecesse.
  */
  function medidas(ctx) {
    var m = ctx.medidas;
    if (m && m.passo > 0 && m.clientWidth > 0) return m;
    /* varrer() ja mediu todos os carrosseis de uma vez, antes de qualquer
       escrita — aproveita, para a montagem nao forcar um layout por carrossel */
    var pre = ctx.el.__epPre;
    if (pre && pre.trilha === ctx.trilha && pre.passo > 0 && pre.clientWidth > 0) {
      ctx.el.__epPre = null;
      ctx.medidas = { passo: pre.passo, clientWidth: pre.clientWidth, scrollWidth: pre.scrollWidth };
      return ctx.medidas;
    }
    m = { passo: passo(ctx.trilha), clientWidth: ctx.scroller.clientWidth, scrollWidth: ctx.scroller.scrollWidth };
    if (m.passo > 0 && m.clientWidth > 0) ctx.medidas = m;
    return m;
  }

  function invalidarMedidas(ctx) {
    ctx.medidas = null;
    ctx.deslocEncaixe = undefined;
  }

  /*
    Deslocamento do encaixe: o scrollLeft de repouso do card i nao e i*passo.
    Com encaixe centralizado o navegador para em i*passo + (inicio do card 0)
    - (clientWidth - largura do card)/2; com encaixe no inicio, em i*passo +
    (inicio do card 0) - scroll-padding. Nos posts do blog (3 cards, centrado)
    dava -17px: a barra, que media scrollLeft % conjunto, lia o 1o card como
    98% e ia parar no fim; o 2o caia no meio e o 3o no fim de novo. Medido
    uma vez por layout (cache, invalidado com as medidas).
  */
  function deslocamentoEncaixe(ctx) {
    if (ctx.deslocEncaixe !== undefined) return ctx.deslocEncaixe;
    var card = ctx.trilha.children[0];
    if (!card) return 0;
    var m = medidas(ctx);
    var rc = card.getBoundingClientRect();
    var inicio = rc.left - ctx.scroller.getBoundingClientRect().left + ctx.scroller.scrollLeft;
    var alvo;
    if (ctx.el.classList.contains('ep-centrado')) alvo = (m.clientWidth - rc.width) / 2;
    else alvo = parseFloat(getComputedStyle(ctx.scroller).scrollPaddingLeft) || 0;
    ctx.deslocEncaixe = inicio - alvo;
    return ctx.deslocEncaixe;
  }

  function indiceAtualCtx(ctx) {
    var p = medidas(ctx).passo;
    return p > 0 ? Math.round(ctx.scroller.scrollLeft / p) : 0;
  }

  /*
    Ha um video tocando dentro deste carrossel?

    O tema tem um freio proprio para isso — o video-component chama
    `armVideoHandoff()` no <simple-carousel> e o autoplay DO TEMA para. Como o
    autoplay do tema esta suprimido e quem gira e o nosso, o freio deixou de
    valer: o carrossel passava por cima do video que o cliente assistia.

    Perguntamos direto aos <video> em vez de ler o `videoHandoffCenterX` do
    tema. O handoff fica ARMADO enquanto a corrente de troca estiver viva, mesmo
    com tudo pausado (ver pausarVideosForaDaVista); usa-lo como sinal prendia o
    autoplay para sempre depois do primeiro play.
  */
  function videoTocando(ctx) {
    var vs = ctx.trilha.querySelectorAll('video');
    for (var i = 0; i < vs.length; i++) {
      if (!vs[i].paused && !vs[i].ended) return true;
    }
    return false;
  }

  /*
    Card saiu da vista: parar o video dele.

    Sozinho o video-component pausaria por visibilidade, mas ele ouve o evento
    `slider-change` que nos disparamos e, na volta, o
    `recoverAfterCarouselSettlement()` RETOMA quem ainda tem a classe
    `is-playing` — inclusive fora da tela. Era por isso que o som continuava
    vindo do card que ja tinha passado. Chamando `pause()` antes, a classe cai
    e a retomada nao acha nada para religar.

    Criterio: menos de 60% do card dentro da area visivel do scroller.
  */
  function pausarVideosForaDaVista(ctx) {
    var comps = ctx.trilha.querySelectorAll('video-component');
    if (!comps.length) return;
    var vista = ctx.scroller.getBoundingClientRect();
    for (var i = 0; i < comps.length; i++) {
      var comp = comps[i];
      var caixa = comp.getBoundingClientRect();
      if (caixa.width <= 0) continue;
      var dentro = Math.min(caixa.right, vista.right) - Math.max(caixa.left, vista.left);
      if (dentro >= caixa.width * 0.6) continue;
      if (typeof comp.pause === 'function') {
        /*
          `preserveHandoff` e o que mantem a corrente viva.

          `pause()` sem argumento chama `disarmCarouselVideoHandoff()`, que zera
          o `videoHandoffCenterX` do <simple-carousel>. E desse ponto que o tema
          parte para escolher o proximo video a tocar
          (`handoffVideoPlaybackInDirection`), entao zerar quebrava a corrente
          depois da PRIMEIRA passada: o segundo card recebia o play, o terceiro
          nao. O tema usa o mesmo argumento no `pauseOtherVideos()` dele.
        */
        comp.pause({ preserveHandoff: true });
      } else {
        var vs = comp.querySelectorAll('video');
        for (var j = 0; j < vs.length; j++) vs[j].pause();
      }
    }
  }

  // ------------------------------------------------------------------ loop --

  /*
    Loop continuo sobre rolagem nativa: TRES conjuntos de slides, repouso no do
    meio.

    A ideia e reposicionar o scrollLeft em uma largura de conjunto ao cruzar uma
    fronteira. O conteudo nas duas posicoes e identico, entao o salto e
    invisivel — e o unico jeito de ter loop sem emenda num container de rolagem,
    ja que voltar ao inicio com animacao mostraria o carrossel desfilando de tras
    para frente.

    Por que tres e nao dois: com dois conjuntos as duas regras de virada se
    disparam mutuamente. Em scrollLeft = conjunto a regra de avanco leva a 0, e
    em 0 a regra de retorno leva de volta a conjunto — ping-pong a cada evento
    de rolagem. Nao se ve um salto, porque o conteudo e o mesmo; ve-se a rolagem
    em curso sendo perturbada. Foi o defeito que o cliente filmou.

    Com tres, o repouso fica na faixa [conjunto, 2*conjunto) e as fronteiras
    ficam a um conjunto inteiro de distancia dos dois lados. Sobra folga para
    arrastar para tras a partir do primeiro slide, que a rolagem nativa nao
    permitiria: ela trava em zero, sem elastico.

    Clonar ou nao clonar — ver podeClonar() logo abaixo.
  */

  /*
    Duas perguntas diferentes que ate agora dividiam a mesma funcao:

      1. O encaixe pode ser CENTRALIZADO? So onde nao ha card de produto —
         banner, topbar, video, posts. Nas vitrines o cliente aprovou o card
         alinhado a esquerda, e isso nao muda.
      2. O conteudo pode ser CLONADO para o loop sem emenda? Essa regra e mais
         permissiva, e e a que mudou.

    Clonar card de produto e seguro QUANDO O SLIDE E O CARD, inteiro e sozinho.
    Nesse formato o <product-card> se auto-inicializa: procura os proprios
    descendentes, nao guarda registro global e nao ha um unico atributo id
    dentro dele (conferido no tema) — a copia vira um card independente, com
    botao de compra que funciona.

    O que continua fora sao os slides COMPOSTOS, que trazem varios cards
    dentro: 'Frequentemente comprados juntos' (10 cards por slide), os
    depoimentos (10) e os cards de video do Tolstoy (8). Clonar ali
    triplicaria dezenas de cards de produto — peso e eventos duplicados sem
    beneficio nenhum.
  */
  var SELETOR_CARD = 'product-card, [class*="product-card"]';

  function semCardDeProduto(trilha) {
    /*
      '[class*=product-card]' e nao so '.product-card': a vitrine
      'Frequentemente comprados juntos' usa 'complementary-product-card', e com
      a checagem estreita ela passava por bloco de conteudo — ganhava clones
      (botao de compra duplicado) e encaixe centralizado.
    */
    return !trilha.querySelector(SELETOR_CARD);
  }

  /* Exatamente um card por slide, contando o PROPRIO elemento: na vitrine o
     slide nao contem o card, ele E o <product-card>. */
  function vitrineDeUmCard(trilha) {
    var filhos = trilha.children;
    if (!filhos.length) return false;
    for (var i = 0; i < filhos.length; i++) {
      var f = filhos[i];
      var proprio = f.matches && f.matches(SELETOR_CARD) ? 1 : 0;
      if (proprio + f.querySelectorAll(SELETOR_CARD).length !== 1) return false;
    }
    return true;
  }

  function podeClonar(trilha) {
    return semCardDeProduto(trilha) || vitrineDeUmCard(trilha);
  }

  function clonar(no) {
    var copia = no.cloneNode(true);
    copia.setAttribute('data-ep-clone', '1');
    copia.setAttribute('aria-hidden', 'true');
    /* clone nao pode ser alvo de tab: seria navegacao duplicada no teclado */
    var focaveis = copia.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    for (var j = 0; j < focaveis.length; j++) focaveis[j].setAttribute('tabindex', '-1');
    return copia;
  }

  function duplicar(ctx) {
    var trilha = ctx.trilha;
    if (ctx.duplicado) return;
    var originais = [].slice.call(trilha.children);
    if (originais.length < 2) return;
    ctx.qtdReal = originais.length;

    /*
      Dois blocos, DUAS insercoes — e nao 40.

      Inserir card por card custava ~20 layouts forcados: cada card e um
      custom element (product-card, buy-button, product-price...) cujo
      connectedCallback le geometria, e cada insercao suja o layout que a
      leitura seguinte forca de novo. Medido em 11/09: 1.619 ms para clonar
      uma vitrine de 10 cards, contra 84 ms de um layout so. Num fragmento,
      os callbacks rodam depois de todos os nos estarem no DOM, entao a
      primeira leitura paga um layout e as demais sao de graca.
    */
    var i;
    var depois = document.createDocumentFragment();
    var antes = document.createDocumentFragment();
    for (i = 0; i < originais.length; i++) {
      depois.appendChild(clonar(originais[i]));
      antes.appendChild(clonar(originais[i]));
    }
    trilha.appendChild(depois);
    trilha.insertBefore(antes, trilha.firstChild);
    ctx.duplicado = true;
    invalidarMedidas(ctx);
  }

  function larguraConjunto(ctx) {
    if (!ctx.duplicado) return 0;
    return medidas(ctx).passo * ctx.qtdReal;
  }

  /*
    Clones sob demanda.

    Clonar na montagem custava caro na home: as 4 vitrines de produto viravam
    3x (10 cards cada -> 30) antes de o visitante ver qualquer uma delas.
    Medido em 09/09: 6.678 elementos a mais, 43% do DOM da pagina, tudo
    abaixo da dobra — e a home com 15.512 elementos contra 8.085 do tema
    anterior. E o tipo de peso que se sente no celular.

    Agora o carrossel nasce sem clones e ganha os tres conjuntos quando chega
    a 600px da tela. Como o autoplay so gira com o carrossel VISIVEL (o
    observador dele nao tem margem), o clone sempre chega antes do primeiro
    giro: o loop continua sem emenda para quem ve, e quem nao rola ate la
    nao paga por ele. Banner e topbar ja estao na tela na carga, entao para
    eles nada muda alem de um tick.

    Tudo que depende de `ctx.duplicado` (barra, bolinhas, normalizar, irPara,
    autoplay) le o valor na hora de usar, por isso da para virar a chave
    depois da montagem sem reconfigurar nada.

    Um conjunto entra ANTES dos originais, o que empurra o conteudo para a
    direita: somamos a largura do conjunto ao scrollLeft para o que estava
    na tela continuar na tela.

    Dois gatilhos, o que vier primeiro:
      - o observador, a uma tela e meia de distancia (150% da altura da
        janela — escala com o aparelho, ao contrario de um valor fixo);
      - o TOQUE no proprio carrossel. touchstart e pointerdown disparam antes
        de o dedo se mover, entao inserir os clones e reposicionar ali nao
        interfere no gesto: quando a rolagem comeca, os produtos "da
        esquerda" ja estao la. Foi o caso que o cliente sentiu no celular:
        chegar rapido numa vitrine e puxar para a direita antes de o
        observador ter clonado — a duplicacao caia no meio do gesto.
    Roda da mouse fica de fora de proposito: o evento wheel ja vem com o
    deslocamento aplicado, e mexer no scrollLeft ali disputaria com ele.
  */
  /*
    Fila: um clone por vez, quando o navegador estiver ocioso.

    Na carga, topbar, banner e a primeira vitrine ja estao na tela; os tres
    observadores disparam no mesmo tick e os tres clones (20-24 custom
    elements se inicializando cada) viravam UMA tarefa de ~650 ms bem no
    meio da carga — o Lighthouse atribuia a tarefa longa a este arquivo.

    Como o autoplay so da o primeiro passo aos 6 s, esses clones podem
    esperar a pagina assentar sem diferenca visivel. Aqui cada pedido entra
    numa fila e sai um por vez em requestIdleCallback (ou 250 ms de
    intervalo onde nao houver). O TOQUE nao passa pela fila: clona na hora,
    porque ai o visitante esta prestes a puxar.
  */
  var filaDeClones = [];
  var drenandoFila = false;
  function drenarFila() {
    if (drenandoFila) return;
    drenandoFila = true;
    var proximo = function () {
      var fn = filaDeClones.shift();
      if (!fn) {
        drenandoFila = false;
        return;
      }
      try {
        fn();
      } catch (e) {
        if (window.console) console.warn('[ep-nativo] clone falhou:', e);
      }
      agendar();
    };
    var agendar = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(proximo, { timeout: 1500 });
      else setTimeout(proximo, 250);
    };
    agendar();
  }

  function agendarClones(ctx) {
    var obs = null;
    var clonar = function () {
      ctx.scroller.removeEventListener('touchstart', clonar, true);
      ctx.scroller.removeEventListener('pointerdown', clonar, true);
      if (obs) obs.disconnect();
      if (ctx.duplicado) return;
      /* geometria lida com o layout ainda limpo: nao forca nada. Depois das
         insercoes, so a escrita do scrollLeft paga um layout — e um so. */
      var passoAntes = passo(ctx.trilha);
      var posAntes = ctx.scroller.scrollLeft;
      duplicar(ctx);
      if (ctx.duplicado) irInstantaneo(ctx.scroller, posAntes + passoAntes * ctx.qtdReal);
    };

    ctx.scroller.addEventListener('touchstart', clonar, { passive: true, capture: true });
    ctx.scroller.addEventListener('pointerdown', clonar, { passive: true, capture: true });

    if (!window.IntersectionObserver) {
      clonar();
      return;
    }
    obs = new IntersectionObserver(
      function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          if (!entradas[i].isIntersecting) continue;
          obs.disconnect();
          filaDeClones.push(clonar);
          drenarFila();
          return;
        }
      },
      { rootMargin: '150% 0px' }
    );
    obs.observe(ctx.el);
    registrarLimpeza(ctx.el, function () {
      ctx.scroller.removeEventListener('touchstart', clonar, true);
      ctx.scroller.removeEventListener('pointerdown', clonar, true);
      if (obs) obs.disconnect();
    });
  }

  /*
    Escrever `scrollLeft` NAO e instantaneo aqui: o CSS deste modo poe
    `scroll-behavior: smooth` no container, e a atribuicao respeita isso. O
    salto do loop sairia animado — ou seja, visivel, que e exatamente o que ele
    existe para evitar. Desligamos o comportamento durante a escrita.
  */
  function irInstantaneo(scroller, posicao) {
    var antes = scroller.style.scrollBehavior;
    scroller.style.scrollBehavior = 'auto';
    scroller.scrollLeft = posicao;
    scroller.style.scrollBehavior = antes;
  }

  function pular(ctx, delta) {
    ctx.pulando = true;
    irInstantaneo(ctx.scroller, ctx.scroller.scrollLeft + delta);
    ctx.pulando = false;
  }

  /*
    Socorro durante o gesto: so nas pontas de verdade (inicio do primeiro
    conjunto, fim do terceiro), onde sem o pulo o dedo bateria na parede.

    Antes a fronteira de cima era o INICIO do terceiro conjunto. Com encaixe
    no comeco do card isso coincide com um repouso e o pulo e invisivel; com
    encaixe centralizado (posts do blog) o repouso fica uns pixels ANTES da
    fronteira, o pulo nao acontecia ali e disparava no meio do arrasto
    seguinte — o pulo do fim para o meio relatado em 12/09. Quem devolve o
    carrossel ao conjunto do meio agora e recentrar(), em repouso.
  */
  function normalizar(ctx) {
    if (!ctx.duplicado) return;
    var conjunto = larguraConjunto(ctx);
    if (conjunto <= 0) return;
    var s = ctx.scroller;
    var m = medidas(ctx);
    var FOLGA_FRONTEIRA = 1;
    if (s.scrollLeft <= FOLGA_FRONTEIRA) pular(ctx, conjunto);
    else if (m.scrollWidth > 0 && s.scrollLeft >= m.scrollWidth - m.clientWidth - FOLGA_FRONTEIRA) pular(ctx, -conjunto);
  }

  /*
    Em repouso, de volta ao conjunto do meio — por INDICE, nao por pixel:
    o repouso de um card e o mesmo card um conjunto adiante, entao o pulo
    cai exatamente sobre outro ponto de encaixe e nada se move na tela.
    Nao roda com o dedo ou o mouse no carrossel: ai o repouso e so uma pausa.
  */
  function recentrar(ctx) {
    if (!ctx.duplicado || ctx.pulando || ctx.tocando) return;
    if (ctx.el.classList.contains('is-dragging')) return;
    var conjunto = larguraConjunto(ctx);
    if (conjunto <= 0 || !ctx.qtdReal) return;
    var i = indiceAtualCtx(ctx);
    if (i >= 2 * ctx.qtdReal) pular(ctx, -conjunto);
    else if (i < ctx.qtdReal) pular(ctx, conjunto);
  }

  var REPOUSO_MS = 120;
  function agendarRecentrar(ctx) {
    if (ctx.timerRepouso) clearTimeout(ctx.timerRepouso);
    ctx.timerRepouso = setTimeout(function () {
      ctx.timerRepouso = null;
      recentrar(ctx);
    }, REPOUSO_MS);
  }

  // ------------------------------------------------------------ navegacao ---

  function irPara(ctx, passos) {
    var p = passo(ctx.trilha);
    if (p <= 0) return;
    var destino = ctx.scroller.scrollLeft + passos * p;

    if (ctx.duplicado) {
      /* com a copia adiante, avancar nunca esbarra no fim */
      ctx.scroller.scrollTo({ left: destino, behavior: suave() });
      return;
    }

    var max = maxRolagem(ctx.scroller);
    if (destino > max + 1) destino = ctx.loopSimples ? 0 : max;
    if (destino < 0) destino = ctx.loopSimples ? max : 0;
    ctx.scroller.scrollTo({ left: destino, behavior: suave() });
  }

  function suave() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  /*
    O <simple-carousel> do tema conversa com a instancia do Blaze para setas,
    paginacao e autoplay. Mantemos o objeto vivo como fachada e trocamos o que
    esta por baixo — mesma estrategia do custom-embla.
  */
  function adaptar(slider, ctx) {
    if (!slider || slider.__epNativoAdaptado) return;
    slider.__epNativoAdaptado = true;

    slider.next = function (n) {
      irPara(ctx, Math.abs(n || 1));
    };
    slider.prev = function (n) {
      irPara(ctx, -Math.abs(n || 1));
    };
    slider.goTo = function (i) {
      var p = passo(ctx.trilha);
      if (p > 0) ctx.scroller.scrollTo({ left: i * p, behavior: suave() });
    };

    try {
      Object.defineProperty(slider, 'stateIndex', {
        configurable: true,
        get: function () {
          var i = indiceAtualCtx(ctx);
          return ctx.qtdReal ? i % ctx.qtdReal : i;
        },
        set: function () {}
      });
    } catch (e) {
      /* noop */
    }
  }

  // ------------------------------------------------------------- autoplay ---

  function ajusteNumero(nome, padrao) {
    var v = parseFloat(ajusteTexto(nome));
    return isNaN(v) || v < 0 ? padrao : v;
  }

  /*
    Interruptor global do loop — Configuracoes do tema > Vitrines e cards de
    produto, um para desktop e outro para celular.

    Ele serve para DESLIGAR, nao para ligar: quem decide continua sendo o
    ajuste de loop de cada carrossel no editor, e aqui apenas se veta. Assim o
    interruptor nunca liga loop onde o bloco nao pediu.

    O corte de 768px e o mesmo que o tema usa nos ajustes de celular.
  */
  function loopLiberado() {
    var nome = window.matchMedia('(min-width: 768px)').matches
      ? '--ep-loop-desktop'
      : '--ep-loop-mobile';
    return ajusteTexto(nome) !== '0';
  }

  /*
    Autoplay.

    Dois ajustes globais (Configuracoes do tema > Vitrines e cards de produto)
    padronizam todos os carrosseis de uma vez, em vez de bloco a bloco:

      --ep-autoplay-intervalo  segundos entre trocas. 0 = usar o valor do
                               proprio bloco, que e o que havia antes: 6s no
                               banner, 5s no topbar e nos demais.
      --ep-autoplay-retomar    segundos parado antes de voltar a girar sozinho.
                               0 = nao retoma, que era o comportamento anterior:
                               uma unica interacao desligava o autoplay de vez.

    O relogio de retomada e reiniciado a cada interacao, entao ele so dispara
    depois de o usuario realmente parar — arrastar tres vezes seguidas nao faz o
    carrossel disputar o gesto com ele.
  */
  function autoplay(ctx, cfg) {
    /*
      Ler do ATRIBUTO e nao de `slider.config`.

      Ao suprimir o autoplay do tema chamamos `stopAutoplay()`, e ele zera o
      `enableAutoplay` DENTRO do objeto do slider. Como a supressao roda na
      varredura, antes da montagem, o nosso autoplay lia `false` e nunca ligava
      — o resultado foi nenhuma vitrine, banner ou topbar passando sozinho.
      O atributo data-slider-config nao e tocado pelo tema.
    */
    var attr = lerConfigAtributo(ctx.el);
    var ligado = typeof attr.enableAutoplay !== 'undefined' ? attr.enableAutoplay : cfg.enableAutoplay;
    if (!ligado) return;

    var globalSeg = ajusteNumero('--ep-autoplay-intervalo', 0);
    var doBloco = parseInt(attr.autoplayInterval || cfg.autoplayInterval, 10) || 5000;
    var intervalo = globalSeg > 0 ? globalSeg * 1000 : doBloco;
    var retomarMs = ajusteNumero('--ep-autoplay-retomar', 0) * 1000;
    var paraAoInteragir =
      typeof attr.stopAutoplayOnInteraction !== 'undefined'
        ? attr.stopAutoplayOnInteraction
        : cfg.stopAutoplayOnInteraction;

    var timer = null;
    var ocioso = null;
    var pausado = false;
    var naTela = true;

    function passoAuto() {
      if (pausado || document.hidden || !naTela) return;
      /* nao passar por cima de quem esta assistindo */
      if (videoTocando(ctx)) return;
      if (!ctx.duplicado && !ctx.loopSimples && ctx.scroller.scrollLeft >= maxRolagem(ctx.scroller) - 1) {
        ctx.scroller.scrollTo({ left: 0, behavior: suave() });
        return;
      }
      irPara(ctx, 1);
    }

    function ligar() {
      if (timer || pausado || !naTela || document.hidden) return;
      timer = setInterval(passoAuto, intervalo);
    }
    function desligar() {
      clearInterval(timer);
      timer = null;
    }

    function interagiu() {
      pausado = true;
      desligar();
      clearTimeout(ocioso);
      if (retomarMs > 0) {
        ocioso = setTimeout(function () {
          pausado = false;
          ligar();
        }, retomarMs);
      }
    }

    if (paraAoInteragir !== false) {
      /* sem `once`: cada interacao precisa reiniciar o relogio de retomada */
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
        ctx.scroller.addEventListener(ev, interagiu, { passive: true, capture: true });
      });
    }

    /* fora da tela nao precisa girar; economiza bateria e trabalho */
    var observador = null;
    if (window.IntersectionObserver) {
      observador = new IntersectionObserver(function (entradas) {
        naTela = !!(entradas[0] && entradas[0].isIntersecting);
        if (naTela) ligar();
        else desligar();
      });
      observador.observe(ctx.el);
    } else {
      ligar();
    }

    var aoTrocarAba = function () {
      if (document.hidden) desligar();
      else ligar();
    };
    document.addEventListener('visibilitychange', aoTrocarAba);

    registrarLimpeza(ctx.el, function () {
      desligar();
      clearTimeout(ocioso);
      if (observador) observador.disconnect();
      document.removeEventListener('visibilitychange', aoTrocarAba);
      if (paraAoInteragir !== false) {
        ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
          ctx.scroller.removeEventListener(ev, interagiu, { passive: true, capture: true });
        });
      }
    });
  }

  // ------------------------------------------------ barra de progresso ------

  function barra(ctx) {
    var sc = ctx.el.closest('simple-carousel');
    if (!sc) return;
    var fill = sc.querySelector('[data-progressbar-fill], .progressbar-fill');
    if (!fill) return;

    /* o tema recalcula a barra pelo stateIndex a cada troca de slide; em
       rolagem nativa quem manda e a posicao, e aquela recalculada prendia a
       barra no minimo */
    sc.updateProgressbar = function () {};

    /*
      A barra e um POLEGAR de rolagem, nao um preenchimento.

      Tentei antes duas semanticas de preenchimento e as duas incomodaram, por
      motivos opostos:
        - so a posicao (scrollLeft / maximo): comeca em zero, mas num bloco de
          poucos cards ia de 4% direto para 100%, sem nada no meio;
        - "quanto ja vi" (posicao + largura visivel): tem meio-termo, mas nasce
          parcialmente cheia — no desktop, com mais cards a mostra, aparecia com
          ~32% ja no primeiro card.

      O polegar resolve os dois: a LARGURA e a fracao visivel (quanto do
      conteudo cabe na tela) e a POSICAO e o quanto ja rolou. No primeiro card
      ele encosta na esquerda, no ultimo encosta na direita — e o tamanho dele
      informa quantos cards existem, que e a leitura que uma barra de rolagem
      da naturalmente.

      Deslocamos com translateX em vez de `left`: o elemento continua no fluxo,
      entao a altura do pai nao colapsa. A porcentagem do translateX e relativa
      a largura do PROPRIO elemento, dai a conversao `esq / largura`.
    */
    var atualizar = function () {
      var scr = ctx.scroller;
      var total;
      var pos;
      if (ctx.duplicado) {
        total = larguraConjunto(ctx);
        /* posicao relativa ao repouso do 1o card real (ver deslocamentoEncaixe) */
        var rel = scr.scrollLeft - deslocamentoEncaixe(ctx);
        pos = total > 0 ? ((rel % total) + total) % total : 0;
        /* erro de 1-2px (passo arredondado) no 1o card cairia em ~total e
           jogaria o polegar para o fim: o ultimo meio passo antes do fim do
           conjunto e lido como 'antes do 1o card' e vira 0 pelo clamp */
        if (pos > total - medidas(ctx).passo / 2) pos -= total;
      } else {
        /* scrollWidth forca layout se lido a cada evento; do cache e exato e gratis */
        total = medidas(ctx).scrollWidth;
        pos = scr.scrollLeft;
      }
      if (!(total > 0)) return;

      /* largura do polegar so muda com resize/clone: escrever so quando muda
         evita sujar o layout a cada evento; o transform e so compositor */
      var largura = Math.max(6, Math.min(100, (medidas(ctx).clientWidth / total) * 100));
      var esquerda;
      if (ctx.duplicado) {
        /* no loop o percurso vai do 1o ao ultimo card real: (qtd-1) passos
           cobrem toda a barra, 1o card encostado a esquerda e ultimo a direita */
        var percurso = (ctx.qtdReal - 1) * medidas(ctx).passo;
        esquerda = percurso > 0 ? Math.max(0, Math.min(100 - largura, (pos / percurso) * (100 - largura))) : 0;
      } else {
        esquerda = Math.max(0, Math.min(100 - largura, (pos / total) * 100));
      }
      var larguraTxt = largura.toFixed(3) + '%';
      if (fill.__epLargura !== larguraTxt) {
        fill.__epLargura = larguraTxt;
        fill.style.width = larguraTxt;
      }
      fill.style.transform = 'translateX(' + (esquerda / largura) * 100 + '%)';
    };
    ctx.aoRolar.push(atualizar);
    atualizar();
  }

  /*
    Avisa o tema quando o slide muda.

    Nem todo carrossel usa barra: o banner da home usa BOLINHAS
    (.blaze-pagination), e quem as move e o proprio tema, pelos callbacks que
    ele registra em `onSlideCbs` do slider. Adaptar `stateIndex` nao basta —
    ninguem le a propriedade sozinho. Sem este aviso as bolinhas ficam paradas
    na primeira, que foi a "barra de progresso do banner que nao funciona".
  */
  /*
    Bolinhas de paginacao.

    O banner da home nao usa barra, usa bolinhas — foi a "barra do banner que
    nao funciona". Marcar a ativa a mao, e nao pelo `updatePagination()` do
    tema: aquele metodo depende do estado interno do Blaze (states, offset,
    normalizacao de center cards) que neste modo nao existe, e o resultado foi
    pior que nao chamar — ele TIRAVA a classe de todas, deixando nenhuma ativa.

    Aqui e o minimo que resolve: uma classe, no indice certo.
  */
  function bolinhas(ctx) {
    var sc = ctx.el.closest('simple-carousel');
    var cont = sc && sc.querySelector('.blaze-pagination');
    if (!cont || !cont.children.length) return null;
    var pontos = [].slice.call(cont.children);

    /* clicar numa bolinha leva ao slide dela */
    pontos.forEach(function (ponto, k) {
      if (ponto.__epLigado) return;
      ponto.__epLigado = true;
      ponto.addEventListener('click', function () {
        var p = passo(ctx.trilha);
        if (p <= 0) return;
        var base = ctx.duplicado ? larguraConjunto(ctx) : 0;
        ctx.scroller.scrollTo({ left: base + k * p, behavior: suave() });
      });
    });
    return pontos;
  }

  function marcarBolinha(ctx, i) {
    if (ctx.pontos === undefined) ctx.pontos = bolinhas(ctx);
    if (!ctx.pontos) return;
    for (var k = 0; k < ctx.pontos.length; k++) {
      ctx.pontos[k].classList.toggle('active', k === i % ctx.pontos.length);
    }
  }

  function avisarTroca(ctx, slider) {
    var sc = ctx.el.closest('simple-carousel');
    if (!slider && !sc) return;
    var cbs = slider ? slider.onSlideCbs || (slider.onSlideCbs = []) : [];
    var ultimo = -1;
    var notificar = function () {
      var i = indiceAtualCtx(ctx);
      if (ctx.qtdReal > 0) i = ((i % ctx.qtdReal) + ctx.qtdReal) % ctx.qtdReal;
      if (i === ultimo) return;
      var inicial = ultimo === -1;
      ultimo = i;

      marcarBolinha(ctx, i);
      /* na montagem nada esta tocando; e a checagem le geometria */
      if (!inicial) pausarVideosForaDaVista(ctx);

      for (var k = 0; k < cbs.length; k++) {
        try {
          cbs[k](i, i, i);
        } catch (e) {
          /* callback do tema quebrou; nao e motivo para parar os outros */
        }
      }
    };
    ctx.aoRolar.push(notificar);
    notificar();
  }

  // --------------------------------------------- arrasto com o mouse --------

  /*
    Porta do carousel-drag-v2.js da SQUADZ. O toque sai fora de proposito: ja
    rola nativamente, e com inercia melhor do que qualquer coisa que a gente
    escreva. Aqui e so o botao esquerdo do mouse.
  */
  /*
    Alvo de uma troca, SEMPRE sobre um ponto de encaixe.

    Escrever uma posicao que nao e ponto de encaixe foi o erro da tentativa
    anterior: eu empurrava para 55% do passo contando que o snap do navegador
    concluisse, e ele nao conclui depois de uma escrita programatica. O
    carrossel ficava parado no meio, com dois banners aparecendo.

    Aqui o destino e sempre `inicio +/- N passos`, arredondado para a grade.
    Mesmo que o navegador resolva o snap dele por cima, os dois candidatos sao
    posicoes validas: o pior caso e nao trocar, nunca ficar torto.

    O limiar e a fracao do passo que ja conta como troca — 0,25 em vez dos 50%
    que o navegador exige sozinho.
  */
  function alvoEncaixado(inicio, delta, passoPx) {
    if (passoPx <= 0) return inicio;
    var distancia = Math.abs(delta);
    var inteiros = Math.floor(distancia / passoPx);
    var resto = distancia - inteiros * passoPx;
    var quantos = inteiros + (resto >= passoPx * TROCA_TOQUE ? 1 : 0);
    var bruto = inicio + (delta < 0 ? -1 : 1) * quantos * passoPx;
    /* a grade comeca em zero, entao arredondar garante o alinhamento mesmo se
       o ponto de partida tiver ficado com sobra de subpixel */
    return Math.max(0, Math.round(bruto / passoPx) * passoPx);
  }

  function arrastoMouse(ctx) {
    var scroller = ctx.scroller;
    var pointerId = null;
    var arrastando = false;
    var xInicial = 0;
    var rolagemInicial = 0;
    var percorrido = 0;
    var fichaAcomodacao = 0;

    function soltarSnap() {
      fichaAcomodacao++; // invalida acomodacao em curso
      ctx.el.classList.add('is-dragging');
    }
    function voltarSnap() {
      ctx.el.classList.remove('is-dragging');
    }

    function acomodar() {
      /* nem todo scroller tem grade: a tabela comparativa so precisa parar onde
         foi solta */
      if (ctx.semEncaixe) {
        voltarSnap();
        return;
      }
      var p = passo(ctx.trilha);
      if (!p) {
        voltarSnap();
        return;
      }
      /* Math.round aqui significava exigir METADE do passo — era a queixa de
         "meio banner" no desktop. Agora vale o mesmo limiar do toque. */
      var alvo = alvoEncaixado(rolagemInicial, scroller.scrollLeft - rolagemInicial, p);
      /* o snap segue desligado durante a acomodacao: com `mandatory` ativo o
         Chrome cancela a rolagem suave programatica no meio do caminho */
      scroller.scrollTo({ left: alvo, behavior: suave() });

      /*
        Nao da para esperar por `scrollend`: o evento do proprio arrasto que
        acabou chega em seguida e restauraria o snap no meio da acomodacao.
        Acompanhamos a posicao ate ela parar de mudar.

        setTimeout e nao requestAnimationFrame de proposito: rAF para de
        disparar com a aba em segundo plano, e a classe is-dragging ficaria
        presa — ela desliga pointer-events dos filhos, o que deixaria o
        carrossel sem cliques. O prazo maximo garante que a classe sempre saia.
      */
      var ficha = ++fichaAcomodacao;
      var anterior = null;
      var estaveis = 0;
      var comecou = Date.now();

      function vigiar() {
        if (ficha !== fichaAcomodacao) return; // outro gesto assumiu
        var atual = Math.round(scroller.scrollLeft);
        estaveis = atual === anterior ? estaveis + 1 : 0;
        anterior = atual;

        if (estaveis >= 2 || Date.now() - comecou > PRAZO_ACOMODACAO) {
          if (Math.abs(scroller.scrollLeft - alvo) > 2) {
            scroller.scrollTo({ left: alvo, behavior: 'auto' });
          }
          voltarSnap();
          return;
        }
        setTimeout(vigiar, 60);
      }
      setTimeout(vigiar, 60);
    }

    function encerrar() {
      if (pointerId === null) return;
      try {
        if (scroller.hasPointerCapture && scroller.hasPointerCapture(pointerId)) {
          scroller.releasePointerCapture(pointerId);
        }
      } catch (e) {
        /* ponteiro ja encerrado */
      }
      pointerId = null;
      if (arrastando) {
        arrastando = false;
        acomodar();
      } else {
        voltarSnap();
      }
    }

    /*
      `capture: true` nao e detalhe. O tema roda isto na inicializacao:

        lockSliderOnVideoInteraction() {
          this.querySelectorAll('video-component:not([data-blaze-drag-lock])')
            .forEach(t => { const e = i => i.stopPropagation();
              t.addEventListener('pointerdown', e); ... })
        }

      Foi feito para impedir o arrasto do Blaze sobre um video. Como o nosso
      ouvinte fica no scroller, que e ancestral, o stopPropagation do alvo o
      apagava — arrastar em cima do video do Tolstoy nao movia nada. Na fase de
      captura nos rodamos ANTES do alvo, entao o bloqueio deixa de importar.
    */
    scroller.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'touch') return; // o toque ja rola nativamente
      if (ev.button !== 0) return;
      if (maxRolagem(scroller) <= 1) return;
      pointerId = ev.pointerId;
      arrastando = false;
      percorrido = 0;
      xInicial = ev.clientX;
      rolagemInicial = scroller.scrollLeft;
    }, true);

    scroller.addEventListener('pointermove', function (ev) {
      if (pointerId === null || ev.pointerId !== pointerId) return;
      var delta = ev.clientX - xInicial;
      percorrido = Math.abs(delta);
      if (!arrastando) {
        if (percorrido < LIMIAR_ARRASTO) return;
        arrastando = true;
        soltarSnap();
        try {
          if (scroller.setPointerCapture) scroller.setPointerCapture(pointerId);
        } catch (e) {
          /* segue sem captura: o gesto ainda funciona dentro do carrossel */
        }
      }
      ev.preventDefault();
      scroller.scrollLeft = rolagemInicial - delta;
    }, true);

    scroller.addEventListener('pointerup', encerrar);
    scroller.addEventListener('pointercancel', encerrar);
    scroller.addEventListener('lostpointercapture', encerrar);

    /* sem isto, soltar o mouse em cima de um card abriria o produto */
    scroller.addEventListener(
      'click',
      function (ev) {
        if (percorrido > LIMIAR_CLIQUE) {
          ev.preventDefault();
          ev.stopPropagation();
          percorrido = 0;
        }
      },
      true
    );

    scroller.addEventListener('dragstart', function (ev) {
      if (arrastando) ev.preventDefault();
    });
  }

  /*
    Distancia de arraste para trocar.

    Com scroll-snap mandatory quem decide ao soltar e o navegador: ele vai para o
    ponto mais proximo, ou seja, exige METADE do passo. No banner e na topbar,
    onde o passo e a tela inteira, isso e meia tela de arrasto.

    Duas tentativas anteriores erraram, e vale registrar porque:

      1. Desligar o snap so durante o gesto nao surte efeito no gesto em curso — o
         navegador ja fixou o comportamento no touchstart. A decisao dele e a
         nossa se somavam.
      2. Desligar o snap PERMANENTEMENTE resolvia a disputa, mas tirava o que
         garante o alinhamento. Qualquer rolagem que a gente nao trate (roda do
         mouse, trackpad, teclado, redimensionar) deixava o banner parado fora de
         posicao — cortado, com o proximo aparecendo do lado.

      3. Empurrar para uma posicao que nao e ponto de encaixe (55% do passo),
         contando que o snap do navegador concluisse: ele nao conclui depois de
         escrita programatica, e o carrossel ficava parado no meio, com dois
         banners a mostra.

    O que vale aqui: o snap fica LIGADO e continua com a palavra final sobre
    alinhamento, e todo destino que escrevemos e `inicio +/- N passos`
    arredondado para a grade (ver alvoEncaixado). Assim, mesmo perdendo a disputa
    com o snap, os dois candidatos sao posicoes validas — o pior caso e nao
    trocar, nunca ficar torto.

    Aprovado pelo cliente em 05/09/2026, depois de quatro tentativas erradas.
  */
  var TROCA_TOQUE = 0.25; // fracao do passo que ja deve trocar
  var VELOCIDADE_FLICK = 0.35; // px/ms; acima disso o proprio navegador ja leva

  function arrastoToque(ctx) {
    var scroller = ctx.scroller;

    /* so onde o passo e praticamente a largura visivel inteira: banner e topbar */
    if (passo(ctx.trilha) < scroller.clientWidth * 0.95) return;

    var inicio = 0;
    var comecou = 0;
    var ativo = false;

    scroller.addEventListener(
      'touchstart',
      function (ev) {
        if (ev.touches.length !== 1) return;
        ativo = true;
        inicio = scroller.scrollLeft;
        comecou = Date.now();
      },
      { passive: true, capture: true }
    );

    scroller.addEventListener(
      'touchend',
      function () {
        if (!ativo) return;
        ativo = false;
        var p = passo(ctx.trilha);
        if (p <= 0) return;

        var delta = scroller.scrollLeft - inicio;
        var distancia = Math.abs(delta);
        var decorrido = Math.max(1, Date.now() - comecou);

        /* gesto rapido: a inercia do proprio navegador ja resolve, e empurrar em
           cima disso passaria de um slide */
        if (distancia / decorrido > VELOCIDADE_FLICK) return;

        /* abaixo do limiar o usuario nao quis trocar */
        if (distancia < p * TROCA_TOQUE) return;

        scroller.scrollTo({ left: alvoEncaixado(inicio, delta, p), behavior: suave() });
      },
      { passive: true, capture: true }
    );

    scroller.addEventListener(
      'touchcancel',
      function () {
        ativo = false;
      },
      { passive: true, capture: true }
    );
  }

  // --------------------------------------------------------------- montagem -

  /*
    Desmontagem.

    Um carrossel e montado mais de uma vez: a poda de produtos chama
    `reload()` e as abas de colecao trocam o `.blaze-track` inteiro. Como o
    `.blaze-track-container` continua sendo O MESMO elemento, tudo que ficou
    pendurado nele na montagem anterior continua vivo — inclusive o
    `setInterval` do autoplay, que segue rolando o mesmo carrossel.

    Era isso que fazia a vitrine trocar DUAS vezes na primeira volta: dois
    autoplays sobre o mesmo scroller, disparando com 1 a 2 segundos de
    diferenca. Depois de um arrasto parecia normalizar porque a trilha antiga
    ja estava fora do DOM e passava a medir zero, deixando o timer velho
    inofensivo — mas ele continuava la.
  */
  function registrarLimpeza(el, fn) {
    (el.__epLimpeza = el.__epLimpeza || []).push(fn);
  }

  function limparMontagem(el) {
    var fns = el.__epLimpeza || [];
    for (var i = 0; i < fns.length; i++) {
      try {
        fns[i]();
      } catch (e) {
        /* uma limpeza que falha nao pode impedir as outras */
      }
    }
    el.__epLimpeza = [];
  }

  /*
    Desliga o autoplay DO TEMA.

    Eu desliguei o arrasto do Blaze mas nao o autoplay do <simple-carousel>, e
    ele chama `slider.next()` — metodo que adaptamos para rolar o nosso
    carrossel. Resultado: DOIS temporizadores girando a mesma vitrine, o do
    tema a 5000ms (config do bloco) e o nosso a 6000ms (ajuste global).

    Como os periodos sao diferentes, eles derivam: as trocas saem em 5,7s,
    5,0s e entao 1,4s quando os dois quase coincidem. Era a "troca dupla" que
    o cliente filmou, e nao tinha relacao com remontagem — a correcao anterior
    (desmontar antes de remontar) resolvia outro defeito real, mas nao este.

    Pista que confirmou: com a pagina OCULTA o nosso autoplay pausa de
    proposito, e mesmo assim havia uma troca a cada ~4,7s. So podia ser o do
    tema.

    `suppressAutoplay` e a propria bandeira do tema — o `setupAutoplayLifecycle`
    dele checa `this.suppressAutoplay && this.stopAutoplay()`. Marcando os dois,
    ele nao volta a ligar sozinho.
  */
  function desligarAutoplayDoTema(sc) {
    if (!sc) return;
    try {
      sc.suppressAutoplay = true;
      if (typeof sc.stopAutoplay === 'function') sc.stopAutoplay();
      if (typeof sc.pauseAutoplayTimer === 'function') sc.pauseAutoplayTimer();
    } catch (e) {
      /* noop */
    }
  }

  function montar(el) {
    /*
      O modal de zoom da PDP fica com o Blaze original. Ele e montado escondido
      (geometria zero), o chunk ProductZoomModal cria/recicla o slider ao abrir
      e sincroniza contador e transform pela API do Blaze; no modo nativo o
      arrasto no celular nao movia nada e no desktop o contador andava sem a
      foto. Um slide por vez em tela cheia nao precisa da rolagem nativa.
    */
    if (el.closest('product-zoom-modal')) return;
    var trilha = el.querySelector('.blaze-track');
    var scroller = el.querySelector('.blaze-track-container');
    /*
      Dois filhos, nao um.

      A vitrine "Voce tambem pode gostar" carrega os produtos DEPOIS, via Section
      Rendering API, e no primeiro passe tem um unico slide de placeholder. Se
      montarmos ali, a decisao de centralizar e tomada sobre um trilho sem cards
      de produto — e a vitrine ganha encaixe centralizado, que deixa meio produto
      de cada lado. Esperar o segundo filho adia a montagem para quando o
      conteudo real chegou; o MutationObserver do varrer() cuida de chamar de
      novo. Carrossel de um slide so nao precisa de carrossel mesmo.
    */
    if (!trilha || !scroller || trilha.children.length < 2) return;

    /*
      Trilha em coluna: carrossel VERTICAL.

      E o caso dos recomendados no carrinho lateral — 2590px de conteudo em
      880px visiveis, rolando para baixo. Todo o tratamento daqui e para rolagem
      horizontal, e o CSS do modo nativo poe `overflow-x: auto; overflow-y:
      hidden` no viewport: aplicado a um carrossel vertical, isso mata o unico
      eixo que ele usa. Ficava so o botao de descer funcionando.

      Saimos antes de tocar em qualquer coisa — inclusive antes de desligar o
      arrasto do Blaze — para deixar o comportamento do tema intacto.
    */
    var pre = el.__epPre && el.__epPre.trilha === trilha ? el.__epPre : null;
    var direcao = pre ? pre.flexDirection : getComputedStyle(trilha).flexDirection || '';
    var trilhaVertical = /^column/.test(direcao);
    if (trilhaVertical) return;

    /* remontagem: abas de colecao e poda trocam o .blaze-track inteiro */
    if (el.__epNativo && el.__epTrilha === trilha) return;
    var remontagem = !!el.__epNativo;
    if (el.__epNativo) limparMontagem(el);
    el.__epNativo = true;
    el.__epTrilha = trilha;

    var slider = el.blazeSlider;
    var cfg = lerConfig(el, slider);

    /* se chegarmos antes do tema, ele pula a instalacao do bloqueio */
    trilha.querySelectorAll('video-component:not([data-blaze-drag-lock])').forEach(function (v) {
      v.setAttribute('data-blaze-drag-lock', 'true');
    });

    desligarArrastoBlaze(trilha);
    desligarAutoplayDoTema(el.closest('simple-carousel'));
    el.classList.add('ep-nativo');
    /*
      Encaixe centralizado onde nao ha card de produto — banner, topbar, video,
      posts e blocos de conteudo. Com uma sobra pequena de cada lado, o card
      ativo fica no meio da tela e os vizinhos aparecem como fatia, que e o que
      sinaliza "tem mais para o lado". Nas vitrines o encaixe segue no inicio:
      card de produto alinhado a esquerda e o que o cliente aprovou.
    */
    var centrado = semCardDeProduto(trilha);
    if (centrado) el.classList.add('ep-centrado');
    trilha.style.transform = 'none';

    var ctx = {
      el: el,
      trilha: trilha,
      scroller: scroller,
      duplicado: false,
      qtdReal: trilha.children.length,
      loopSimples: false,
      pulando: false,
      tocando: false,
      timerRepouso: null,
      aoRolar: []
    };

    if (cfg.loop && loopLiberado()) {
      if (podeClonar(trilha)) agendarClones(ctx);
      else ctx.loopSimples = true; // slide composto: sem clone, volta ao inicio
    }

    /*
      O padding lateral do viewport (5vw) desalinha o encaixe: o scroll-snap
      mira a borda do scrollport, que fica antes do padding, e o card aparece
      deslocado para a esquerda. scroll-padding move o alvo do snap para dentro.
    */
    var padEsq = pre ? pre.paddingLeft : getComputedStyle(scroller).paddingLeft;
    if (!centrado && parseFloat(padEsq) > 0) scroller.style.scrollPaddingLeft = padEsq;

    adaptar(slider, ctx);
    barra(ctx);
    avisarTroca(ctx, slider);
    arrastoMouse(ctx);
    arrastoToque(ctx);
    autoplay(ctx, cfg);

    /* marca se ha o que arrastar; muda com a largura da tela */
    var marcarArrastavel = function () {
      invalidarMedidas(ctx);
      var m = medidas(ctx);
      el.classList.toggle('ep-arrastavel', m.scrollWidth - m.clientWidth > 1);
    };
    /* na montagem, sem invalidar: a medida acabou de vir da pre-leitura */
    (function () {
      var m = medidas(ctx);
      el.classList.toggle('ep-arrastavel', m.scrollWidth - m.clientWidth > 1);
    })();
    window.addEventListener('resize', marcarArrastavel);

    var aoRolarTudo = function () {
      if (ctx.pulando) return;
      normalizar(ctx);
      agendarRecentrar(ctx);
      for (var i = 0; i < ctx.aoRolar.length; i++) ctx.aoRolar[i]();
    };
    var aoTocar = function () {
      ctx.tocando = true;
    };
    var aoSoltar = function () {
      ctx.tocando = false;
      agendarRecentrar(ctx);
    };
    scroller.addEventListener('scroll', aoRolarTudo, { passive: true });
    scroller.addEventListener('touchstart', aoTocar, { passive: true });
    scroller.addEventListener('touchend', aoSoltar, { passive: true });
    scroller.addEventListener('touchcancel', aoSoltar, { passive: true });

    registrarLimpeza(el, function () {
      window.removeEventListener('resize', marcarArrastavel);
      scroller.removeEventListener('scroll', aoRolarTudo, { passive: true });
      scroller.removeEventListener('touchstart', aoTocar, { passive: true });
      scroller.removeEventListener('touchend', aoSoltar, { passive: true });
      scroller.removeEventListener('touchcancel', aoSoltar, { passive: true });
      if (ctx.timerRepouso) clearTimeout(ctx.timerRepouso);
    });

    /*
      Posicao inicial. Com loop, o repouso e o comeco do conjunto do meio —
      e quando os clones chegam depois (agendarClones), e o proprio clonar()
      que reposiciona.

      Sem loop tambem precisa ancorar em zero: numa troca de aba de colecao o
      scroller MANTEM o scrollLeft anterior, que nao corresponde a grade do
      conteudo novo — e o primeiro card volta deslocado para a esquerda.
    */
    if (ctx.duplicado) irInstantaneo(scroller, larguraConjunto(ctx));
    else if (remontagem) irInstantaneo(scroller, 0);
    /* na primeira montagem o scroller ja esta em zero: escrever scrollLeft
       forcaria um layout por carrossel, para nada */
  }

  /*
    Mega menu do cabecalho: empilhar as colunas curtas quando UMA domina.

    Mora neste arquivo por economia de requisicao — ele e o unico JS proprio
    do tema, e um arquivo a mais custaria mais que estas 20 linhas.

    A decisao nao cabe no CSS, que nao mede altura. O criterio e o mesmo que
    o olho usa: a maior coluna sozinha e mais alta que a soma das outras.
    Medido em 1600px:

      Treino          326, 199, 265  -> maior 326 < outras 464  -> lado a lado
      Cafes & Snacks  172, 108, 489  -> maior 489 > outras 280  -> empilha

    Bate com o julgamento do cliente nos dois casos: no Treino as tres tem
    altura parecida e ficam bem em tres colunas; em Cafes uma e enorme e as
    outras duas cabem juntas ao lado dela.

    O empilhamento em si e do CSS (column-count), aqui so entra a marcacao.
  */
  /*
    Lista longa sem submenus em duas colunas (desktop).

    "Proteina" tem 15 links numa coluna so: o menu ficava com 450px de altura
    e os banners ao lado, esticados para acompanhar. Com 12+ itens a lista vira
    grade de 2 colunas (CSS em custom-overrides, .ep-duas-colunas); o numero
    de linhas vai em --ep-linhas porque o CSS nao conta filhos. "Ver todos"
    fica embaixo, ocupando as duas colunas. Medido em 1440px: menu 450 -> 268px
    de altura, trilha dos links 218 -> 405px, banners 415 -> 335px.
  */
  function duasColunasNoMenu() {
    document.querySelectorAll('.mega-menu__links-wrapper--no-submenus').forEach(function (w) {
      var lista = w.querySelector('.mega-menu__links-list');
      if (!lista) return;
      var n = lista.querySelectorAll('.mega-menu__links-list-item:not(.mega-menu__links-list-item--view-all)').length;
      var duas = n >= 12;
      w.classList.toggle('ep-duas-colunas', duas);
      if (duas) lista.style.setProperty('--ep-linhas', String(Math.ceil(n / 2)));
    });
  }

  function equilibrarMegaMenu() {
    duasColunasNoMenu();
    /* duas passadas: LER a altura de todos os menus e so depois ESCREVER as
       classes. Intercalado, cada escrita sujava o layout que a leitura do
       menu seguinte forcava — seis layouts da pagina inteira na carga. */
    var decisoes = [];
    document.querySelectorAll('.mega-menu__links-wrapper').forEach(function (w) {
      var cols = [];
      var todas = w.querySelectorAll('.mega-menu__column');
      for (var i = 0; i < todas.length; i++) {
        if (todas[i].parentElement === w) cols.push(todas[i]);
      }
      if (cols.length < 3) {
        decisoes.push({ w: w, empilhar: false });
        return;
      }
      var maior = 0;
      var soma = 0;
      for (var k = 0; k < cols.length; k++) {
        var h = cols[k].scrollHeight;
        soma += h;
        if (h > maior) maior = h;
      }
      decisoes.push({ w: w, empilhar: maior > soma - maior });
    });
    for (var d = 0; d < decisoes.length; d++) {
      decisoes[d].w.classList.toggle('ep-empilhar', decisoes[d].empilhar);
    }
  }

  /*
    Arrasto com o mouse na tabela comparativa da pagina de produto.

    Ela e um scroller horizontal como os carrosseis, mas nao passa pelo
    montar(): nao tem .blaze-track. Reaproveitamos o mesmo arrastoMouse —
    o do tema da SQUADZ — montando um contexto minimo. Sem encaixe: as
    colunas nao comecam na origem do scroller (a coluna de rotulos fica numa
    area de grid separada), entao arredondar para multiplos do passo pararia
    sempre alguns pixels fora.
  */
  function montarArrastoTabela() {
    document.querySelectorAll('.comparative-table__table').forEach(function (scroller) {
      if (scroller.__epArrasto) return;
      var raiz = scroller.closest('.comparative-table') || scroller.parentElement;
      var trilha = scroller.querySelector('.comparative-table__columns');
      if (!raiz || !trilha) return;
      scroller.__epArrasto = true;
      arrastoMouse({
        el: raiz,
        trilha: trilha,
        scroller: scroller,
        semEncaixe: true,
        duplicado: false,
        qtdReal: 0,
        loopSimples: false,
        pulando: false,
        aoRolar: []
      });
      var marcar = function () {
        raiz.classList.toggle('ep-arrastavel', scroller.scrollWidth - scroller.clientWidth > 1);
      };
      marcar();
      window.addEventListener('resize', marcar);
    });
  }

  /*
    Destaque nas linhas de cabecalho e de grupo das tabelas nutricionais.

    Nao da para fazer so com CSS: TODAS as linhas usam a mesma classe
    (`nutritional-table__row--data`) e todas tem duas celulas. O que separa
    uma linha de grupo ("Essenciais", "Nao Essenciais", "*Total de BCAAs") de
    uma linha de dado e a segunda celula estar vazia — grupo nao tem valor.
    A primeira linha de cada tabela e o cabecalho ("25g | % Valor Diario").
  */
  function marcarLinhasTabela() {
    document.querySelectorAll('.nutritional-table__body').forEach(function (corpo) {
      var linhas = corpo.querySelectorAll('.nutritional-table__row');
      for (var i = 0; i < linhas.length; i++) {
        var linha = linhas[i];
        if (linha.__epMarcada) continue;
        linha.__epMarcada = true;
        var celulas = linha.children;
        var segundaVazia = celulas.length > 1 && !(celulas[1].textContent || '').trim();
        /*
          "Segunda celula vazia" sozinho nao serve: "Acucares totais (g) 1,9" tem
          a coluna de %VD vazia e caia como grupo. Linha de grupo nao traz numero
          nenhum — "Essenciais", "Nao Essenciais". A excecao e "*Total de BCAAs:
          18,2g", que tem numero mas e sempre a ULTIMA linha da tabela.
        */
        var semNumero = !/[0-9]/.test((celulas[0] || linha).textContent || '');
        /* "*Total de BCAAs" abre com asterisco e nao e a ultima linha do corpo */
        var comAsterisco = /^\s*\*/.test((celulas[0] || linha).textContent || '');
        if (i === 0) linha.classList.add('ep-linha-topo');
        else if (comAsterisco || (segundaVazia && semNumero)) linha.classList.add('ep-linha-grupo');
      }
    });
  }

  /*
    Latching da roda do mouse.

    Chrome, dentro de UM gesto continuo, se prende ao scroller interno e nao
    repassa para a pagina ao chegar na ponta — mesmo com a cadeia livre
    (`overscroll-behavior-y: auto`, que ja corrigimos no CSS). Sao coisas
    diferentes: overscroll-behavior governa o ENCADEAMENTO, latching governa a
    quem o gesto pertence. Nao existe CSS para o segundo.

    Entao assumimos o evento: se a roda pede para descer e o scroller ja esta
    no fim (ou pede para subir e ja esta no topo), cancelamos e rolamos a
    janela na mao. No meio do conteudo nao tocamos em nada — o scroller
    interno funciona normalmente.

    So com ponteiro fino. No toque nao ha latching, e um preventDefault ali
    atrapalharia a rolagem nativa.
  */
  /*
    Rolagem da pagina no lugar do gesto que assumimos.

    `window.scrollBy` puro e um salto seco, e sente-se mais brusco que a
    rolagem normal — o Chrome anima a roda com suavizacao propria. Aqui
    animamos tambem.

    O acumulador existe porque `scrollTo` suave RECALCULA a partir da posicao
    atual: como a animacao anterior ainda esta a meio caminho, somar o passo
    sobre `window.scrollY` perderia distancia a cada tique da roda. Guardando
    o alvo, tiques seguidos somam sobre ele e o total percorrido bate com o
    que a roda pediu. O alvo expira depois de 200ms parado.
  */
  var alvoPagina = null;
  var expiraAlvo = null;
  var redeDeSeguranca = null;

  function rolarPaginaSuave(passo) {
    var doc = document.documentElement;
    var maximo = Math.max(0, doc.scrollHeight - window.innerHeight);
    var base = alvoPagina === null ? window.scrollY : alvoPagina;
    var destino = Math.max(0, Math.min(maximo, base + passo));
    var partida = window.scrollY;
    alvoPagina = destino;

    window.scrollTo({ top: destino, behavior: suave() });

    clearTimeout(expiraAlvo);
    expiraAlvo = setTimeout(function () {
      alvoPagina = null;
    }, 200);

    /*
      Rede de seguranca. Nos cancelamos o evento da roda, entao se a rolagem
      suave nao sair do lugar a pagina fica PARADA — pior que o salto seco que
      esta correcao veio consertar. A rolagem suave depende de quadros de
      animacao, e ha contextos onde eles nao vem (aba em segundo plano, por
      exemplo). Se em 120ms nada andou, vai direto.
    */
    clearTimeout(redeDeSeguranca);
    redeDeSeguranca = setTimeout(function () {
      var andou = Math.abs(window.scrollY - partida) >= 1;
      var chegou = Math.abs(window.scrollY - destino) < 1;
      if (!andou && !chegou) window.scrollTo({ top: destino, behavior: 'auto' });
    }, 120);
  }

  function liberarRolagemNoFim(scroller) {
    if (scroller.__epLiberado) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    scroller.__epLiberado = true;

    scroller.addEventListener(
      'wheel',
      function (ev) {
        if (ev.ctrlKey) return; /* zoom do navegador */
        if (scroller.scrollHeight <= scroller.clientHeight + 1) return;

        var passo = ev.deltaY;
        /* deltaMode: 0 pixels, 1 linhas, 2 paginas */
        if (ev.deltaMode === 1) passo *= 16;
        else if (ev.deltaMode === 2) passo *= scroller.clientHeight;
        if (!passo) return;

        var fim = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
        var topo = scroller.scrollTop <= 0;
        if (!((passo > 0 && fim) || (passo < 0 && topo))) return;

        ev.preventDefault();
        rolarPaginaSuave(passo);
      },
      { passive: false }
    );
  }

  // ------------------------------------------ imagem da variante (kits) ----

  /*
    Troca a CAPA quando a variante muda.

    O tema foi feito para produto de UMA variante: cada sabor e um produto
    separado, e trocar de sabor navega para outra pagina. Por isso a galeria
    nunca reagiu a troca de variante. O primeiro produto com variantes de
    verdade foi o KIT do app Bundles — 40 combinacoes, com foto propria — e
    a foto nao acompanhava.

    A galeria desse tipo de produto vem do main-product-images-kit.liquid,
    que marca o wrapper com data-galeria-kit e deixa nos data-* o que este
    codigo precisa:
      data-capa-src / data-capa-zoom  a foto generica de capa, para voltar
                                      quando a variante nao tem foto propria
      data-fotos-variantes            JSON { idDaVariante: { pos, src } } so
                                      com as variantes que TEM foto propria;
                                      pos e o indice no modal de zoom

    Decidimos pelo ID da variante (detail.variantId), e nao pela URL que o
    evento traz em detail.image: o JSON do seletor devolve a imagem de
    destaque do produto para variante sem foto — e no kit a imagem de destaque
    e a foto de uma variante. Pela URL nao da para distinguir; pelo id da.
    (Esse detail.image continua intocado: e ele que poe a miniatura certa no
    carrinho.)

    A capa e o hero no desktop e o primeiro slide no celular — e o unico
    lugar que muda. Regra do cliente: variante sem foto propria volta para a
    capa generica, nao fica presa na foto da variante anterior.
  */
  function lerFotosDasVariantes(galeria) {
    try {
      return JSON.parse(galeria.getAttribute('data-fotos-variantes') || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function aplicarCapa(no, src, zoom) {
    if (!no) return;
    var img = no.querySelector('img');
    if (img) {
      img.src = src;
      img.removeAttribute('srcset');
    }
    var botao = no.querySelector('[data-zoom-index]');
    if (botao) botao.setAttribute('data-zoom-index', String(zoom));
  }

  function sincronizarImagemDaVariante() {
    document.addEventListener(
      'variant-change',
      function (ev) {
        var secao = ev.target && ev.target.closest ? ev.target.closest('.shopify-section') : null;
        var galeria = secao && secao.querySelector('.main-product__images[data-galeria-kit]');
        if (!galeria) return;

        var id = String((ev.detail && ev.detail.variantId) || '');
        var foto = lerFotosDasVariantes(galeria)[id];
        var src;
        var zoom;
        if (foto && foto.src) {
          src = foto.src;
          zoom = foto.pos;
        } else {
          src = galeria.getAttribute('data-capa-src');
          zoom = parseInt(galeria.getAttribute('data-capa-zoom'), 10) || 0;
        }
        if (!src) return;

        aplicarCapa(galeria.querySelector('.main-product__hero'), src, zoom);
        aplicarCapa(galeria.querySelector('.main-product__images--mobile [data-slide-capa]'), src, zoom);

        /* no celular a capa e o primeiro slide: volta para ele */
        var scroller = galeria.querySelector('.main-product__images--mobile .blaze-track-container');
        if (scroller && scroller.scrollLeft > 0) scroller.scrollTo({ left: 0, behavior: suave() });
      },
      true
    );
  }

  function liberarScrollersInternos() {
    var sel =
      '.nutritional-tables__primary-scroll, .nutritional-tables__secondary-scroll, .nutritional-table__body';
    document.querySelectorAll(sel).forEach(liberarRolagemNoFim);
  }

  /*
    Blocos de app vazios na coluna de infos da PDP.

    O bloco de assinaturas (Vindi) renderiza so espaco em branco quando o
    produto nao tem plano, mas a Shopify sempre embrulha o app block num
    <div class="shopify-app-block"> — que segue sendo item do flex e soma um
    gap de 24px acima do botao de comprar (NUTDOP 500g, 13/09/2026). Liquid
    nao consegue omitir esse embrulho. Aqui: sem elemento filho e sem texto,
    ganha ep-vazio (display:none no CSS); um observer devolve se o app
    injetar conteudo depois. O conteudo do Vindi vem do servidor, entao na
    pratica nao ha piscada.
  */
  /*
    Contadores da super oferta sem a unidade "dias" quando ela esta em 00.

    O componente do tema (countdown-timer) escreve os quatro valores a cada
    segundo, sempre com os quatro blocos. Nos cards "00 dias | 14 hrs | 16 min
    | 23 seg" gasta espaco com uma informacao nula; marketplaces mostram
    hh:mm:ss e so acrescentam os dias quando falta mais de um. Aqui: observa o
    <span> dos dias e marca o timer com ep-sem-dias (CSS esconde a unidade e o
    separador seguinte). Horas ficam sempre — e o formato de relogio que o
    cliente reconhece e a largura nao pula na ultima hora.
  */
  function ajustarTimersSemDias() {
    document.querySelectorAll('countdown-timer').forEach(function (timer) {
      if (timer.__epSemDias) return;
      var dias = timer.querySelector('[data-countdown-days]');
      if (!dias) return;
      timer.__epSemDias = true;
      var avaliar = function () {
        var v = parseInt(dias.textContent, 10);
        timer.classList.toggle('ep-sem-dias', v === 0);
      };
      avaliar();
      new MutationObserver(avaliar).observe(dias, { childList: true, characterData: true, subtree: true });
    });
  }

  function esconderBlocosDeAppVazios() {
    document.querySelectorAll('.main-product__infos > .shopify-app-block').forEach(function (el) {
      if (el.__epVazio) return;
      el.__epVazio = true;
      var avaliar = function () {
        var vazio = !el.firstElementChild && !el.textContent.trim();
        el.classList.toggle('ep-vazio', vazio);
      };
      avaliar();
      new MutationObserver(avaliar).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function varrer() {
    ajustarTimersSemDias();
    /* cada etapa no seu try: um erro na poda nao pode impedir a montagem */
    try {
      document.querySelectorAll('simple-carousel').forEach(podarVitrine);
    } catch (e) {
      if (window.console) console.warn('[ep-nativo] poda de vitrine falhou:', e);
    }
    /* o tema pode inicializar o autoplay dele DEPOIS da nossa montagem */
    document.querySelectorAll('simple-carousel').forEach(desligarAutoplayDoTema);

    /*
      Pre-leitura: toda a geometria de todos os carrosseis ANTES de montar
      qualquer um. A montagem escreve (classes, transform, scroll-padding);
      se cada carrossel lesse a propria geometria depois das escritas do
      anterior, cada leitura forcaria um layout da pagina inteira — eram 11
      layouts em sequencia, a tarefa longa de 750 ms que o Lighthouse
      atribuia a este arquivo. Lendo tudo junto, com o layout limpo, e um so.
    */
    var sliders = document.querySelectorAll('.blaze-slider');
    for (var s = 0; s < sliders.length; s++) {
      var el0 = sliders[s];
      if (el0.closest('product-zoom-modal')) continue;
      var tr0 = el0.querySelector('.blaze-track');
      var sc0 = el0.querySelector('.blaze-track-container');
      if (!tr0 || !sc0 || tr0.children.length < 2) continue;
      if (el0.__epNativo && el0.__epTrilha === tr0) continue;
      el0.__epPre = {
        trilha: tr0,
        flexDirection: getComputedStyle(tr0).flexDirection || '',
        paddingLeft: getComputedStyle(sc0).paddingLeft,
        passo: passo(tr0),
        clientWidth: sc0.clientWidth,
        scrollWidth: sc0.scrollWidth
      };
    }

    sliders.forEach(function (el) {
      try {
        montar(el);
      } catch (e) {
        if (window.console) console.warn('[ep-nativo] falhou em um carrossel:', e);
      }
    });
  }

  // ------------------------------- Shopify Forms so onde ha formulario ----

  /*
    O app Shopify Forms entra como incorporacao global: um loader de 0,7 KB
    que a Shopify injeta no fim do <head>, e que por sua vez injeta um index.js
    de 252 KB — em TODA pagina, sem checar se ha formulario. Lido no proprio
    loader em 11/09/2026: a injecao e incondicional. A loja usa o Forms em tres
    paginas (Prescritores, Trabalhe conosco, Fale conosco), todas com o bloco
    inline. Na home e nas colecoes eram 252 KB de JavaScript para nada — o
    maior script isolado da pagina.

    O loader fica FORA do content_for_header (a Shopify o acrescenta depois de
    todo o conteudo do tema), entao Liquid nao alcanca. Este arquivo roda
    antes dele — os dois sao defer, e este vem primeiro no <head> — e por isso
    consegue interceptar: se a pagina nao tem nenhum bloco do Forms, a
    insercao do index.js e ignorada.

    O sinal de "tem formulario" e o placeholder que o bloco renderiza no
    servidor: <div data-form-root="true" data-forms-id="forms-root-...">. O
    <shopify-forms-embed> NAO serve — e o index.js que o cria, entao nunca
    existe na hora da decisao.

    O gancho vive so ate o DOMContentLoaded (os scripts defer ja rodaram) e
    depois o appendChild original volta. So intercepta script cujo src casa
    com forms-<n>/assets/index.js; todo o resto passa direto.

    Falha aberta: se o app mudar o jeito de injetar, o gancho nao casa e o
    comportamento volta a ser o de hoje (carrega em toda pagina). Nada quebra.

    Formulario POPUP do Forms (que abre em qualquer pagina) deixaria de
    aparecer onde nao ha bloco inline. Para esse caso existe o ajuste
    "Carregar o Forms em todas as paginas" (Configuracoes do tema > Shopify
    Forms), que chega aqui como --ep-forms-global e desliga o gancho inteiro.
    Hoje nao existe popup nenhum, e o ajuste nasce desligado.
  */
  function formsSoOndeHaFormulario() {
    if (ajusteTexto('--ep-forms-global') === '1') return;
    if (document.querySelector('[data-form-root]')) return;
    var original = Node.prototype.appendChild;
    var padrao = /forms-\d+\/assets\/index\.js/;
    var gancho = function (no) {
      if (no && no.tagName === 'SCRIPT' && padrao.test(no.src || '') && !document.querySelector('[data-form-root]')) {
        return no; /* nao insere: 252 KB poupados */
      }
      return original.call(this, no);
    };
    var restaurar = function () {
      if (Node.prototype.appendChild === gancho) Node.prototype.appendChild = original;
    };
    Node.prototype.appendChild = gancho;
    document.addEventListener('DOMContentLoaded', restaurar);
    setTimeout(restaurar, 5000); /* rede de seguranca */
  }

  /* precisa rodar JA, antes do loader do Forms — nao dentro do pronto() */
  formsSoOndeHaFormulario();

  pronto(function () {
    varrer();
    var pendente = false;
    /*
      So vale a pena varrer quando ENTRA carrossel novo (secao carregada
      depois, aba de colecao trocando a trilha, recomendacoes). Antes a
      varredura rodava a cada mutacao do DOM — e a home tem um cronometro de
      oferta mutando a cada segundo, ou seja, varredura completa (11
      carrosseis, getComputedStyle em cada) a cada segundo, para sempre.
      Nossos proprios clones tambem nao contam: sao cards, nao carrosseis.
    */
    var SEL_CARROSSEL = 'simple-carousel, .blaze-slider, .blaze-track';
    var trouxeCarrossel = function (mutacoes) {
      for (var i = 0; i < mutacoes.length; i++) {
        var add = mutacoes[i].addedNodes;
        if (!add.length) continue;
        /*
          Trilha que GANHA filhos sem estar montada: e a vitrine "Voce tambem
          pode gostar", que nasce com um placeholder (montar() espera dois
          filhos) e recebe os cards depois, pela Section Rendering API. O
          filtro por carrossel novo deixava essa vitrine para sempre com o
          Blaze do tema: sem loop, sem bloqueio de clique ao soltar o arrasto,
          passo de um em um. Nossos clones entram em trilha ja montada, entao
          nao passam por aqui.
        */
        var alvo = mutacoes[i].target;
        if (alvo.nodeType === 1 && alvo.classList.contains('blaze-track')) {
          var dono = alvo.closest('.blaze-slider');
          if (dono && !dono.__epNativo) return true;
        }
        for (var j = 0; j < add.length; j++) {
          var n = add[j];
          if (n.nodeType !== 1) continue;
          if (n.matches(SEL_CARROSSEL) || n.querySelector(SEL_CARROSSEL)) return true;
        }
      }
      return false;
    };
    new MutationObserver(function (mutacoes) {
      if (pendente || !trouxeCarrossel(mutacoes)) return;
      pendente = true;
      setTimeout(function () {
        pendente = false;
        varrer();
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
    equilibrarMegaMenu();
    montarArrastoTabela();
    marcarLinhasTabela();
    esconderBlocosDeAppVazios();
    ajustarTimersSemDias();
    setTimeout(ajustarTimersSemDias, 1500);
    setTimeout(ajustarTimersSemDias, 4000);
    liberarScrollersInternos();
    sincronizarImagemDaVariante();
    setTimeout(liberarScrollersInternos, 1500);
    setTimeout(marcarLinhasTabela, 1500);
    setTimeout(montarArrastoTabela, 1500);
    setTimeout(equilibrarMegaMenu, 1500);
    var reMenu = null;
    window.addEventListener('resize', function () {
      clearTimeout(reMenu);
      reMenu = setTimeout(equilibrarMegaMenu, 300);
    });
    setTimeout(varrer, 1200);
    setTimeout(varrer, 3000);
  });
})();
